/**
 * Mixin global para controlar o modo visualização (viewOnly)
 * 
 * Quando viewOnly=true na URL:
 * - Desabilita todos os botões de ação (criar, editar, deletar)
 * - Torna campos de formulário readonly
 * - Oculta botões de submissão
 * 
 * IMPORTANTE: Os dados são carregados como se fossem do gestor sendo visualizado.
 * O backend recebe o header X-View-As-Manager-Id e filtra os dados adequadamente.
 */

export default {
  computed: {
    /**
     * Verifica se está em modo visualização (somente leitura)
     * Usa Vuex store para melhor performance
     */
    isViewOnlyMode() {
      return this.$store.getters.isViewOnlyMode
    },
    
    /**
     * Retorna props para desabilitar inputs quando em viewOnly
     */
    viewOnlyInputProps() {
      if (this.isViewOnlyMode) {
        return {
          readonly: true,
          disabled: false,
          persistentHint: true,
          hint: 'Modo visualização - não é possível editar'
        }
      }
      return {}
    },
    
    /**
     * Nome do gestor sendo visualizado
     */
    viewOnlyManagerName() {
      return this.$store.getters.viewOnlyManagerName || this.$route.query.managerName || ''
    },
    
    /**
     * ID do gestor sendo visualizado
     */
    viewOnlyManagerId() {
      return this.$store.getters.viewOnlyManagerId || this.$route.params.managerId || null
    },
    
    /**
     * Role do gestor sendo visualizado
     */
    viewOnlyManagerRole() {
      return this.$store.getters.viewOnlyManagerRole || this.$route.query.managerRole || ''
    }
  },
  
  methods: {
    /**
     * Retorna à tela de seleção de gestor (Tenant Admin)
     */
    exitViewOnlyMode() {
      this.$router.push('/tenant-admin')
    },
    
    /**
     * Verifica se uma ação pode ser executada (bloqueia se viewOnly)
     */
    canPerformAction(actionName = 'esta ação') {
      if (this.isViewOnlyMode) {
        this.$store.commit('setSnackbar', {
          show: true,
          color: 'warning',
          text: `Você está em modo visualização. Não é possível realizar ${actionName}.`
        })
        return false
      }
      return true
    },
    
    /**
     * Wrapper para métodos de criação/edição/exclusão
     * Uso: this.withViewOnlyCheck(() => this.createItem())
     */
    withViewOnlyCheck(callback) {
      if (this.canPerformAction()) {
        return callback()
      }
    }
  }
}
